function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 7.126v2.141A2.008 2.008 0 002 11a2 2 0 003.732 1h2.142a3.99 3.99 0 01-.924 1.702A4 4 0 113 7.126zM6 6v3h3a2 2 0 011.995 1.85L11 11v2a1 1 0 01-1.993.117L9 13v-2H6a2 2 0 01-1.995-1.85L4 9V6h2zm6.5-6a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm-2.086 2.122a2.5 2.5 0 003.464 3.464l-3.464-3.464zM5 1a2 2 0 110 4 2 2 0 010-4zm7.5 0c-.51 0-.983.152-1.378.414l3.464 3.464A2.5 2.5 0 0012.5 1z",
    fill: "#212A33",
    fillRule: "evenodd"
  }));
}

export var ReactComponent = SvgComponent;
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/service/ic_wheelchair_inaccessible.svg";